import VueCompositionAPI from "@vue/composition-api";
import { ModalPlugin, ToastPlugin } from "bootstrap-vue";
import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

import App from "./App.vue";
import router from "./router";
import store from "./store";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/sweet-alerts";
import "@/libs/toastification";
import "@/libs/vue-select";

import "@/libs/tour";

window.$ = window.jQuery = require("jquery");

import Ripple from "vue-ripple-directive";

Vue.directive("ripple", Ripple);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

Vue.use(VueLocalStorage);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

import api_host from "@/config/api_host";
import { dataCeneter } from "@/data/DataCenter";
import { LogCenter } from "@/data/LogCenter";

import { httpService } from "@/service/http_service";
import { alertUtil } from "@/tools/alert_util";
import { global } from "@/tools/global";
import { toastUtil } from "@/tools/toast_util";
import { verify } from "@/tools/verify_util";

Vue.prototype.$global = global;
Vue.prototype.$httpService = httpService;
Vue.prototype.$alert = alertUtil;
Vue.prototype.$toast = toastUtil;
Vue.prototype.$version = api_host.version;

dataCeneter.user = dataCeneter.getData();
Vue.prototype.$dataCeneter = dataCeneter;
Vue.prototype.$logCenter = LogCenter;
Vue.prototype.$verify = verify;

window.$verify = verify;
window.$alert = alertUtil;

// 全域 mixin，用於在 .r-read-only 底下的 input 禁用
// 在Vue實例的data中添加isMounted屬性
Vue.mixin({
  data() {
    return {
      isMounted: false,
    };
  },
  mounted() {
    this.isMounted = true;
  },
  updated() {
    if (this.isMounted) {
      this.disableInputsInReadOnly();
    }
  },
  methods: {
    disableInputsInReadOnly() {
      const readOnlyElements = document.querySelectorAll(".r-read-only");
      if (readOnlyElements.length > 0) {
        readOnlyElements.forEach((readOnlyElement) => {
          const inputAndTextareaElements =
            readOnlyElement.querySelectorAll("input, textarea");
          inputAndTextareaElements.forEach((element) => {
            element.disabled = true;
          });
        });
      }
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



